import { X } from 'lucide-react';

export default function PeoplePickerClearButton({
  label,
  onClear,
}: {
  label: string;
  onClear: () => void;
}) {
  return (
    <button
      type="button"
      aria-label={`Clear ${label.toLowerCase()}`}
      onClick={onClear}
      style={{
        position: 'absolute',
        right: 4,
        top: 4,
        display: 'flex',
        width: 24,
        height: 24,
        alignItems: 'center',
        justifyContent: 'center',
        color: 'var(--nb-muted)',
      }}
    >
      <X size={13} aria-hidden />
    </button>
  );
}
